// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"highlighted-badge_shadow__8V-3s","badge":"highlighted-badge_badge__3Tsmz"};